export default __webpack_public_path__ + "static/media/longCloud20.fd73dbf8.webp";